/* eslint-disable react/no-unknown-property */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { ChildrenType, MixType } from 'Type/Common.type';

/** @namespace Scandipwa/Component/Tab/Component */
export class TabComponent extends PureComponent {
    static propTypes = {
        mix: MixType.isRequired,
        isActive: PropTypes.bool.isRequired,
        children: ChildrenType.isRequired
    };

    render() {
        const { children, isActive, mix } = this.props;

        if (!isActive) {
            return null;
        }

        return (
            <div block="Tab" mix={ mix }>
                { children }
            </div>
        );
    }
}

export default TabComponent;
